module.exports = __webpack_public_path__ + "img/science_communication.daf6e345.svg";